import React from 'react';
import DataResource from '../../../common/v4/DataResource'
import Panel from '../../../common/layout/Panel'
import config from '../../../../config';

export default class extends React.Component {
    render () {
        const data = {
            url: `/admin/reports/invoices`,
            data: {
                data: [],
                metadata: []
            },
            userfilter:
            [
                {
                    source: 'ATRINVCREATE',
                    label: 'Invoice Created',
                    type: 'date_range',
                    default: {'from' : new Date(), 'to': new Date() }
                }
            ],
            userFilterExpandable: true,
            userFilterSimple: true,
            onclick: 'link',
            link: `/reports/invoices/{id}`,
            metadata: [
                {
                    label: 'ID',
                    source: 'ATRINVID',
                    type: 'primary',
                    visible: false
                },
                {
                    label: 'Number',
                    source: 'ATRINVNUMBER',
                    type: 'text',
                },
                {
                    label: 'Issued To',
                    source: 'entity_name',
                    type: 'text',
                },
                {
                    label: 'Issued Date',
                    source: 'ATRINVCREATE',
                    type: 'date',
                },
                {
                    label: 'Period Start',
                    source: 'ATRINVSTDT',
                    type: 'date',
                },
                {
                    label: 'Period End',
                    source: 'ATRINVENDT',
                    type: 'date',
                },
                {
                    label: 'Amount',
                    source: 'ATRINVTOTAL',
                    type: 'money',
                },
                {
                    label: 'Currency',
                    source: 'currency_name',
                    type: 'text',
                },
                {
                    label: 'PDF',
                    source: 'pdf_path',
                    type: 'link_href',
                    value: `${config.usageReport.basePath}{$pdf_path}`,
                },
                {
                    label: 'Usage Report',
                    source: 'link_to_usage',
                    type: 'link_href',
                    value: `${config.usageReport.basePath}{$link_to_usage}`,
                },
                {
                    label: 'Delete', 
                    type: 'delete',
                }
            ]
        }
        return (
            <Panel title = "Invoice List">
                <DataResource
                    data = {data}
                    {...this.props} 
                    disableAdd
                    pagination
                />
            </Panel>
        )
    }
}